export default "__VITE_ASSET__BIwwuycI__"